import { ChangeDetectorRef, Directive, EventEmitter, Injector, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SetDirty } from '@Core/models/proprietary/page/page.actions';
import { PageState } from '@Core/models/proprietary/page/page.state';

@Directive()
export abstract class EditPanelComponent {
    readOnlyMode: boolean = false;
    //set to true in descendant to bypass automatic readonly setting based on Page State Service -- should be rare
    ignorePageState: boolean = false;
    //set to true in descendant to bypass setting pageState.Dirty when anyFormChangeSub detects a change -- should be rare
    ignoreDirtyTracking: boolean = false;

    @Input()
    allowClose: boolean = false;

    @Output()
    onClose = new EventEmitter();

    pageEventSub: Subscription;
    pageReadOnlyModeSub: Subscription;

    form: UntypedFormGroup;
    protected formChangeSub: Subscription;
    protected anyFormChangeSub: Subscription;

    store: Store;
    changeDet: ChangeDetectorRef;
    fb: UntypedFormBuilder;

    constructor(private inj: Injector) {
        this.store = inj.get(Store);
        this.changeDet = inj.get(ChangeDetectorRef);
        this.fb = inj.get(UntypedFormBuilder);
    }

    ngOnInit() {
        if (!this.ignorePageState) {
            //listen for page events
            this.pageEventSub = this.store.select(PageState.pageEvent).subscribe((x) => {
                if (x == 'HighlightErrors') {
                    this.highlightErrors();
                }
                if (x == 'Reset') {
                    this.reset();
                }
                //if (x == 'ReadOnlyMode') { this.readonly(true) };
                //if (x == 'EditMode') { this.readonly(false) }
            });

            this.pageReadOnlyModeSub = this.store.select(PageState.readOnlyMode).subscribe((x) => {
                this.readonly(x);
            });
            this.anyFormChangeSub = this.form.valueChanges.subscribe((value) => {
                if (!this.ignoreDirtyTracking) {
                    this.store.dispatch(new SetDirty());
                }
            });
        }
        this.applyRules();
    }

    //move into service or extend form directive
    disableControl(control: any, disableCondition: boolean = true) {
        if (typeof control === 'string' || control instanceof String) {
            //path to control passed in as a string -- otherwise the  control was passed in
            control = this.form.get(control.toString());
        }
        if (control && control != null) {
            if (this.readOnlyMode == true) {
                control.disable({ emitEvent: false });
            } else {
                disableCondition ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
            }
        }
    }

    ngOnDestroy() {
        if (this.pageEventSub) {
            this.pageEventSub.unsubscribe();
        }
        if (this.formChangeSub) {
            this.formChangeSub.unsubscribe();
        }
        if (this.anyFormChangeSub) {
            this.anyFormChangeSub.unsubscribe();
        }
        if (this.pageReadOnlyModeSub) {
            this.pageReadOnlyModeSub.unsubscribe();
        }
    }

    //stub function -- this should be overridded in inheritor  //TODO:  IS there a way force this function to be declared in inheritor?
    applyRules() {
        //!!!DO NOT ADD CODE HERE -- ADD CODE IN THE INHERITOR!!!
    }

    highlightErrors() {
        this.markAsTouched(this.form);
        this.changeDet.detectChanges();
    }

    markAsTouched(group: UntypedFormGroup | UntypedFormArray) {
        Object.keys(group.controls).map((field) => {
            const control = group.get(field);
            if (control instanceof UntypedFormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {
                this.markAsTouched(control);
            }
        });
    }

    reset() {
        this.markAsUntouched(this.form);
        this.changeDet.detectChanges();
    }

    readonly(value: boolean) {
        this.readOnlyMode = value;
        this.disableControl(this.form, value);
        if (value == false) {
            this.applyRules(); //reapply rules after re-enabling all controls above
        }

        //ML - The following detect changes call was causing a ViewDestroyedError
        //     There might be a better way of detecting if the view is destroyed before
        //     calling change detection
        // this.changeDet.detectChanges();
        if (!this.changeDet['destroyed']) {
            this.changeDet.detectChanges();
        }
    }

    tempRefreshForm() {
        //TODO:  HACK!   this is to force form into proper readonly mode.    
        // Use in decendant if form won't stay in readonly mode when navigating to section

        setTimeout(() => {
            this.readonly(this.readOnlyMode);
        }, 1);
    }

    //TODO:   should we keep this???   Currently we use in the vehicle edit panel html template to get values to construct the title
    getControl(path: string): AbstractControl {
        return this.form.get(path);
    }

    //TODO:   should we keep this???   Currently we use in the contract edit panel html template to get values for the favorites control
    getControlValue(path: string): any {
        let formControl = this.form.get(path);
        if (formControl) {
            return formControl.value;
        }
        return null;
    }

    markAsUntouched(group: UntypedFormGroup | UntypedFormArray) {
        Object.keys(group.controls).map((field) => {
            const control = group.get(field);
            if (control instanceof UntypedFormControl) {
                control.markAsUntouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {
                this.markAsUntouched(control);
            }
        });
    }

    close() {
        this.onClose.emit();
    }
}
